import { useEffect, useRef, useState } from 'react'
import { Platform, type GestureResponderEvent, type ScrollView } from 'react-native'

export const useHorizontalWheelScroll = () => {
  const scrollViewRef = useRef<ScrollView>(null)
  const [isScrollEnabled, setIsScrollEnabled] = useState(false)

  useEffect(() => {
    const handleHorizontalWheelScroll = (e: GestureResponderEvent) => {
      if ('wheelDeltaX' in e && e.wheelDeltaX === 0) {
        e.preventDefault()
        e.stopPropagation()
        if (scrollViewRef.current) {
          // @ts-expect-error - scrollLeft is not a property of type ScrollView
          scrollViewRef.current.scrollTo({ x: scrollViewRef.current.scrollLeft + e.wheelDelta, animated: true })
        }
      }
    }

    if (scrollViewRef.current && Platform.OS === 'web') {
      const scrollView = scrollViewRef.current
      // @ts-expect-error - addEventListener is not a property of ScrollView
      scrollView.addEventListener('wheel', handleHorizontalWheelScroll)

      return () => {
        // @ts-expect-error - removeEventListener is not a property of ScrollView
        scrollView.removeEventListener('wheel', handleHorizontalWheelScroll)
        setIsScrollEnabled(false)
      }
    }
  }, [isScrollEnabled])

  const enableScroll = () => setIsScrollEnabled(true)

  return {
    scrollViewRef,
    isScrollEnabled,
    enableScroll,
  }
}
